import { DOMAIN_NOT_RESOLVING_ERROR_TYPE, VARIATION_CATEGORY_NOT_SYNCED_ERROR_TYPE } from '../constants/PublishArticleErrors';
export function isDomainNotConnectedError(error) {
  return error.responseJSON && error.responseJSON.errorType === DOMAIN_NOT_RESOLVING_ERROR_TYPE;
}
export function isVariationCategoryNotSynced(error) {
  return error.responseJSON && error.responseJSON.errorType === VARIATION_CATEGORY_NOT_SYNCED_ERROR_TYPE;
}